import {localize, setLocale} from '@vee-validate/i18n'
import de from '@vee-validate/i18n/dist/locale/de.json'
import en from '@vee-validate/i18n/dist/locale/en.json'
import * as AllRules from '@vee-validate/rules'
import {configure, defineRule, ErrorMessage, Field, Form} from 'vee-validate'
import zxcvbn from "zxcvbn"
import additionalDe from './vee-validate/de'
import additionalEn from './vee-validate/en'

const url_regex = '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$' // fragment locator

const rulesForErrorMessage = [
    'validation_pending',
    'juleica_card_number_doesnt_match_with_contact',
    'juleica_invalid',
    'iban_invalid',
    'phone_invalid',
    'puzzle_unsolved',
    'pending',
    'valid_domain',
    'deeply_nested',
]

const expectedDateFormats = ['DD.MM.YYYY', 'DD.MM.YY', 'D.M.YYYY', 'D.M.YY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD']

export default defineNuxtPlugin((nuxtApp) => {

    const dayjs = useDayjs()
    /**************
     * Custom rules
     **************/

    defineRule('verify_password', value => value && zxcvbn(value).score > 2)
    defineRule('confirm_password', (value, [password]) => value === password)
    defineRule('verify_url', value => new RegExp(url_regex, 'i').test(value))
    defineRule('editor_content_required', value => !(value === "" || value?.replaceAll(' ', '') === '<p></p>'))

    defineRule('is_regex', (value) => {
        try {
            new RegExp(value)
        } catch (e) {
            return false
        }
        return true
    })

    defineRule('regex_with_message', (value, {regex, message}) => {
        if (!value || value.toString().match(regex)) return true
        return message
    })

    defineRule('includes', (value, {text, message}) => {
        if (value?.toString().toLowerCase().includes(text.toLowerCase())) return true
        return message ? message : false

    })

    defineRule('valid_date', (value) => {
        try {
            return !!expectedDateFormats.some(format => dayjs(value, format, true).isValid())
        } catch (e) {
            return false
        }
    })

    defineRule('date_is_after', (value, [date]) => {
        if (!date) return true
        const errorMessage = 'Das Datum muss nach dem ' + dayjs(date).format('DD.MM.YYYY') + ' liegen.'
        if (!value) return errorMessage
        try {
            // Check if the value matches any of the expected formats
            const validFormat = expectedDateFormats.find(format => dayjs(value, format, true).isValid()) ?? null
            return dayjs(value, validFormat).isSameOrAfter(date) ? true : errorMessage
        } catch (e) {
            return errorMessage
        }
    })

    defineRule('date_is_before', (value, [date]) => {
        if (!date) return true
        const errorMessage = 'Das Datum muss vor dem ' + dayjs(date).format('DD.MM.YYYY') + ' liegen.'
        if (!value) return errorMessage
        try {
            const validFormat = expectedDateFormats.find(format => dayjs(value, format, true).isValid()) ?? null
            return dayjs(value, validFormat).isSameOrBefore(date) ? true : errorMessage
        } catch (e) {
            return errorMessage
        }
    })

    rulesForErrorMessage.forEach(rule => defineRule(rule, () => false))

    /**************
     * Configuration
     **************/

    Object.keys(AllRules).forEach(rule => {
        if (rule === 'all') return
        defineRule(rule, AllRules[rule])
    })

    setLocale('de')

    configure({
        generateMessage: localize({
            de: {...de, messages: {...de.messages, ...additionalDe.messages}},
            en: {...en, messages: {...en.messages, ...additionalEn.messages}}
        })
    })

    nuxtApp.vueApp.component("VField", Field)
    nuxtApp.vueApp.component("VForm", Form)
    nuxtApp.vueApp.component("ErrorMessage", ErrorMessage)

    configure({
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid',
            dirty: ['is-dirty', 'is-dirty'] // multiple classes per flag!
        }
    })
})